function SectionHeading({ text, className }: any) {
  return (
   <div className="flex items-center gap-3">
    <span className="h-6 w-1.5 rounded-full bg-[var(--red)]" />
    <p className="text-[20px] font-bold tracking-tight text-white max-sm:text-[18px]">
      {text}
    </p>
  </div>
  );
}

export default SectionHeading;
 
 
 
 
